import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = {
  name: 'Food',
  icon: 'mdi-clipboard-outline',
  path: '/reports/mcd/controlsFood/',
  children: [
    // todo add ending inventory
    {
      path: '/reports/mcd/controlsFood/physicalInventory',
      name: 'Inventory',
      meta: { id: 'reports-physicalInventory' },
      component: () =>
        import('@/views/mcd/food/inventory/inventoryWrapper.vue'),
      ...addPermissionsToRoute(['physicalInventory']),
      tags: ['Ending Inventory Cost'],
    },
    {
      path: '/reports/mcd/controlsFood/transfers',
      name: 'Transfers',
      meta: { id: 'reports-transfers' },
      component: () => import('./transfers/transfersReport.vue'),
      ...addPermissionsToRoute(['transfers']),
    },
    {
      path: '/reports/mcd/controlsFood/fob',
      name: 'Food Over Base',
      meta: { id: 'reports-fob' },
      component: () => import('@/views/standard/food/foodOverBase.vue'),
      ...addPermissionsToRoute(['fob']),
      tags: ['Controllable Food Cost Components', 'fob'],
    },
    {
      path: '/reports/mcd/controlsFood/inventoryCount',
      name: 'Raw Item Counts',
      meta: { id: 'reports-rawItemCount' },
      component: () => import('@/views/standard/food/rawItemCount.vue'),
      ...addPermissionsToRoute(['inventoryStat']),
    },
    {
      path: '/reports/mcd/controlsFood/rawWastePromo',
      name: 'Raw Waste & Promo',
      meta: { id: 'reports-rawWastePromo' },
      component: () =>
        import('@/views/standard/food/rawWaste/RawWastePromoWrapper.vue'),
      ...addPermissionsToRoute(['wastePromo']),
    },
    {
      path: '/reports/mcd/controlsFood/wastePromoDetail',
      name: 'Comp Waste Detail',
      meta: { id: 'reports-compWasteDetail' },
      component: () => import('./compWaste/CompWasteDetailWrapper.vue'),
      ...addPermissionsToRoute(['wastePromo']),
      tags: ['Completed Waste Detail'],
    },
  ],
};

export default routes;
